import {MinLength } from 'class-validator';
export class Login {
    @MinLength(1)
    UserName: string;
    @MinLength(3)
    Password: string;
    RememberMe: boolean;
    ChangePassword: boolean;
}
